<span *ngIf="memberStatusLabel" [className]="cssClassName">{{memberStatusLabel}}</span>
